import AnnouncementPageId from "@mapmycustomers/shared/enum/announcements/AnnouncementPageId";
import Announcement from "@mapmycustomers/shared/types/announcements/Announcement";

import AnnouncementCta from "@app/types/AnnouncementCta";

import getAnnouncementCta from "./getAnnouncementCta";
import getAnnouncementImageUrl from "./getAnnouncementImageUrl";

export interface AnnouncementButtonAnalyticsProperties {
  announcementId: Announcement["id"];
  announcementName: Announcement["name"];
  position: number; // 1-based
  total: number;
}

export interface AnnouncementCardAnalyticsProperties extends AnnouncementButtonAnalyticsProperties {
  hasCta: boolean;
  hasMedia: boolean;
  pageId: AnnouncementPageId | undefined;
}

export interface AnnouncementCtaAnalyticsProperties extends AnnouncementCardAnalyticsProperties {
  ctaLabel: AnnouncementCta["label"];
  ctaPageId?: Extract<AnnouncementCta, { kind: "page" }>["pageId"];
}

export const getAnnouncementButtonAnalyticsProperties = (
  announcement: Announcement,
  index: number,
  total: number
): AnnouncementButtonAnalyticsProperties => ({
  announcementId: announcement.id,
  announcementName: announcement.name,
  position: index + 1,
  total,
});

const getAnnouncementAnalyticsProperties = (
  announcement: Announcement,
  index: number,
  total: number,
  pageId: AnnouncementPageId | undefined
): AnnouncementCardAnalyticsProperties => ({
  ...getAnnouncementButtonAnalyticsProperties(announcement, index, total),
  hasCta: !!getAnnouncementCta(announcement),
  hasMedia: !!getAnnouncementImageUrl(announcement),
  pageId,
});

// An external CTA reports its label only: its URL never goes to analytics.
export const getAnnouncementCtaAnalyticsProperties = (
  cardProperties: AnnouncementCardAnalyticsProperties,
  cta: AnnouncementCta
): AnnouncementCtaAnalyticsProperties => ({
  ...cardProperties,
  ctaLabel: cta.label,
  ...(cta.kind === "page" ? { ctaPageId: cta.pageId } : {}),
});

export default getAnnouncementAnalyticsProperties;
